import EAVVehicle from "../images/Electric/EAVP1Cargo.png";
import ECAVehicle from "../images/Electric/Fuso.png";
import ENVVehicle from "../images/Electric/eNV.png";
import PARVehicle from "../images/Electric/peugeot.png";
import PAXVehicle from "../images/Electric/Paxster.png";
import VITVehicle from "../images/Electric/vito.png";
export const DRIVER_RATING_MIN = 3;
export const GREEN_VEHICLE_TYPE_CODE_LIST = ["ENV", "ECA", "EAV", "PAX", "RED", "PAR", "VIT"]; // NOTE - noone has heard of RED vehicle type so this will default to ENV

export const VEHICLE_IMAGE_MAP = {
  EAV: EAVVehicle,
  ECA: ECAVehicle,
  ENV: ENVVehicle,
  PAR: PARVehicle,
  PAX: PAXVehicle,
  RED: ENVVehicle,
  VIT: VITVehicle
};